import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/lib/site";
import HomePage from "@/pages/HomePage";
import StaticPage from "@/pages/StaticPage";
import AdminApp from "@/admin/AdminApp";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream p-8 text-center">
          <div>
            <p className="font-head text-2xl font-extrabold text-forest-900">حدث خطأ غير متوقع</p>
            <p className="mt-2 text-sm text-moss">يرجى تحديث الصفحة والمحاولة من جديد.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ScrollManager() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <SiteProvider>
        <ScrollManager />
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<StaticPage kind="privacy" />} />
            <Route path="/terms" element={<StaticPage kind="terms" />} />
            <Route path="/admin" element={<AdminApp />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </ErrorBoundary>
  );
}

export default App;
